<script setup lang="ts">
withDefaults(defineProps<{
  modelValue?: number
  indeterminate?: boolean
  size?: number
  width?: number
  color?: string
}>(), {
  size: 32,
  width: 3,
  color: 'primary',
})

const colorMap: Record<string, string> = {
  primary: 'var(--m-primary)',
  secondary: 'var(--m-secondary)',
  error: 'var(--m-error)',
  warning: 'var(--m-warning)',
  success: 'var(--m-success)',
  info: 'var(--m-info)',
  white: '#ffffff',
}
</script>

<template>
  <svg
    class="m-progress-circular"
    :class="{ 'm-progress-circular--indeterminate': indeterminate }"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    role="progressbar"
  >
    <circle
      class="m-progress-circular__track"
      cx="12" cy="12"
      :r="10"
      fill="none"
      :stroke-width="width"
    />
    <circle
      class="m-progress-circular__bar"
      cx="12" cy="12"
      :r="10"
      fill="none"
      :stroke="colorMap[color] || color"
      :stroke-width="width"
      stroke-linecap="round"
      :stroke-dasharray="indeterminate ? '31.4 31.4' : `${(modelValue || 0) * 0.628} 62.8`"
    />
  </svg>
</template>

<style scoped>
.m-progress-circular__track {
  stroke: var(--m-border-light);
}

.m-progress-circular--indeterminate {
  animation: m-circ-spin 0.8s linear infinite;
}

@keyframes m-circ-spin {
  to { transform: rotate(360deg); }
}
</style>
